<template>
	<div>
		<v-toolbar flat fixed>
	        <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

	        <v-toolbar-title class="white--text">Taxable Value Transactions</v-toolbar-title>
	    </v-toolbar>

	    <div class="hasToolbar grey-back">
	    	<v-list nopadding>
	    		<template v-for="(item, index) in transactionItems">
	    			<v-list-tile :key="index">
	                  	<v-list-tile-content>
	                      	<v-list-tile-title>{{item}}</v-list-tile-title>
	                  	</v-list-tile-content>
	              	</v-list-tile>		
	    		</template>
	    	</v-list>
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				transactionItems:null
			}
		},
		methods:{
			fn_getTransactionItems: function(){
				let self = this;
		        this.getData('UnEditTransactions', null, 
		            {
		              onSuccess: function(response){
		                  console.log(response);
		                  self.transactionItems = JSON.parse(response);
		              }, 
		              onError: function(error){
		                  console.log(error);
		                  self.userType = null;
		              }
		            }
		        );
			}
		},
		mounted: function(){
			this.fn_getTransactionItems();
		}
	}
</script>	


// WEBPACK FOOTER //
// src/components/settings/tempview.vue